function getID(value){
    console.log("-------111")
    let child = document.querySelectorAll(".what_in_box");
    for (var i = 0; i< child.length; i++) {
        var id = child[i].children[0].id
     
        if(value == id){
             document.getElementById(id).parentNode.style.setProperty('display','block','important')
             console.log(value,id,"1111")
           
        }else{
            document.getElementById(id).parentNode.style.setProperty('display','none','important')
              console.log(value,id,"2222")
     
           
        }
     
        
        // if (id.includes(value)) {
        //     document.getElementById(id).parentNode.style.setProperty('display','block','important')
        // } else {
        //     document.getElementById(id).parentNode.style.setProperty('display','none','important')
        // }
    }    
}




